import RejectedApplications from "../Administration/RejectedApplications";

const DivisionRejectedPermission = ({ role }) => {
  return (
    <>
      <RejectedApplications role={role} />
    </>
  );
};

export default DivisionRejectedPermission;
